import React from 'react';
import { aboutParagraphs, missionPillars, topSkills } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
import { IndustryBackdrop } from '../components/IndustryBackdrop';
export function About() {
  return <section className="relative min-h-[70vh] overflow-hidden bg-parchment pt-32 pb-24 lg:pb-32" data-id="element-55" data-mp="29lghn1fz00oq">
      <IndustryBackdrop data-id="element-56" data-mp="2eizvi08rabg5" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-57" data-mp="328azdqleklyi">
        <SectionHeading eyebrow="EXECUTIVE SUMMARY" title="About Christine Eaton" data-id="element-58" data-mp="3292iw31q6t8f" />

        <div className="mt-14 grid gap-16 lg:grid-cols-[1.35fr_0.65fr]" data-id="element-59" data-mp="3762n08f0llww">
          <div data-id="element-60" data-mp="2sawjbs3e5z6q">
            {aboutParagraphs.map((paragraph, index) => <p key={paragraph.slice(0, 24)} className={`text-lg leading-relaxed text-slate-700 ${index === 0 ? 'text-xl text-ink' : 'mt-6'}`} data-id="element-61" data-mp="2x8y189p2zsgm" data-mpi={index}>
                {paragraph}
              </p>)}

            <div className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-62" data-mp="1uhs4z38yytbv">
              {missionPillars.map(pillar => <div key={pillar.title} className="border-t border-ink/15 pt-5" data-id="element-63" data-mp="1pj8gav2zr3ft">
                  <h3 className="text-xl text-ink" data-id="element-64" data-mp="23iggnraw4hll">{pillar.title}</h3>
                  <p className="mt-2 text-base leading-relaxed text-slate-600" data-id="element-65" data-mp="23jrkfr4c5pcp">{pillar.copy}</p>
                </div>)}
            </div>
          </div>

          <aside className="self-start bg-white p-8 ring-1 ring-ink/10" data-id="element-66" data-mp="2dfmcfcug8ws5">
            <h3 className="text-sm tracking-wider2 text-grass-600" data-id="element-67" data-mp="28i2xeapxgfz5">TOP SKILLS</h3>
            <ul className="mt-5 space-y-4" data-id="element-68" data-mp="2m8y87sjzl75d">
              {topSkills.map(skill => <li key={skill} className="border-b border-ink/10 pb-4 text-lg text-ink" data-id="element-69" data-mp="2masi8btpzeuo">
                  {skill}
                </li>)}
            </ul>
            <p className="mt-8 text-base leading-relaxed text-slate-600" data-id="element-70" data-mp="2w7nfkre9b97d">
              A leadership style built on a bias for action, developing and empowering teams, and
              elevating the influence of procurement at executive level.
            </p>
          </aside>
        </div>
      </div>
    </section>;
}